import React, { useEffect } from "react";
import "./Toast.css";

export default function Toast({ mensaje, tipo = "success", onClose }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose?.();
    }, 3200);
    return () => clearTimeout(timer);
  }, [onClose]);

  const iconos = {
    success: "✓",
    error: "!",
    info: "i",
  };

  return (
    <div className={`toast-ios ${tipo}`}>
      <div className="toast-ios-box">
        <span className="toast-icon">{iconos[tipo] || "i"}</span>
        <span className="toast-msg">{mensaje}</span>
      </div>
    </div>
  );
}